import VendorDetailsDesktop from './desktop';
import VendorDetailsMobile from './mobile';
interface Props {
  mode: 'mobile' | 'desktop';
}
const VendorDetails = ({
  mode
}: Props) => {
  if (mode === 'mobile') return <VendorDetailsMobile />;
  return <VendorDetailsDesktop data-sentry-element="VendorDetailsDesktop" data-sentry-component="VendorDetails" data-sentry-source-file="index.tsx" />;
};
export default VendorDetails;